function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { createPortal } from 'react-dom';
import { actions as modalActions } from '../../../../reducers/modal.reducer';
import { actions as cmsActions } from '../../../../reducers/cms.reducer';
import { actions as ppcActions } from '../../../../reducers/ppc.reducer';
import { actions as posActions } from '../../../../reducers/pos.reducer';
import Button from '../../Button.react';
import AssetsOrUpload from './AssetsOrUpload.modal';
import UploadImage from './UploadImage.react';
import AssetViewerModal from './AssetViewer.modal';
import Cropper from '../../Cropper.react';
var AddImage = function AddImage(_ref) {
  var blobType = _ref.blobType,
    _onCrop = _ref.onCrop,
    onSelect = _ref.onSelect,
    _ref$permission = _ref.permission,
    permission = _ref$permission === void 0 ? null : _ref$permission,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var dispatch = useDispatch();
  var _useState = useState(uuid()),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showAssetViewer = _useState6[0],
    toggleShowAssetViewer = _useState6[1];
  var _useState7 = useState({
      visible: false,
      asset: null,
      assetID: null,
      reCrop: false,
      filename: null
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    cropper = _useState8[0],
    setCropper = _useState8[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    label: "Add Image",
    apiID: "add-image-button",
    className: className,
    onClick: function onClick() {
      if (disabled) return;
      dispatch({
        type: modalActions.add,
        payload: {
          component: /*#__PURE__*/React.createElement(AssetsOrUpload, {
            loading: loading,
            onSelect: function onSelect(val) {
              if (val === 'upload') $("#".concat(id)).click();else toggleShowAssetViewer(true);
            }
          })
        }
      });
    },
    permission: permission
  }), /*#__PURE__*/React.createElement(UploadImage, {
    id: id,
    setLoading: setLoading,
    onUploaded: function onUploaded(asset) {
      dispatch({
        type: modalActions.hide
      });
      if (_onCrop) setCropper(_objectSpread(_objectSpread({}, cropper), {}, {
        visible: true,
        asset: asset,
        filename: asset.filename
      }));else if (onSelect) onSelect(asset);
    }
  }), /*#__PURE__*/React.createElement(Cropper, {
    visible: cropper.visible,
    asset: cropper.asset,
    assetID: cropper.assetID,
    type: blobType,
    onClose: function onClose() {
      return setCropper(_objectSpread(_objectSpread({}, cropper), {}, {
        visible: false
      }));
    },
    onCrop: function onCrop(_ref2) {
      var crop = _ref2.crop,
        assetID = _ref2.assetID;
      if (_onCrop) _onCrop({
        id: null,
        blobType: blobType,
        assetID: assetID,
        filename: cropper.filename,
        crop: {
          x: crop.x,
          y: crop.y,
          w: crop.width,
          h: crop.height
        }
      });
      setCropper({
        visible: false,
        asset: null,
        assetID: null,
        reCrop: false,
        filename: null
      });
    }
  }), showAssetViewer && /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement(AssetViewerModal, {
    onSelect: function onSelect(asset) {
      setCropper(_objectSpread(_objectSpread({}, cropper), {}, {
        visible: true,
        asset: asset,
        filename: asset.filename
      }));
      dispatch({
        type: modalActions.hide
      });
      toggleShowAssetViewer(false);
    },
    onClose: function onClose() {
      return toggleShowAssetViewer(false);
    }
  }), document.getElementById('root')));
};
export default AddImage;